<div fxFlex="row" fxFlex>
    <div fxFlex="240px" class="sidenavigationTop hidexs" *ngIf="showFooter">
       
        <div class="iwg-service-name" *ngIf="ShowEOREstimator || !EORDisabled" >Employer of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;">
        <div *ngIf="ShowEOREstimator">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c']" [queryParams]="{service: 1, global_scope: 2}">
            Estimator<span flex></span>
            <span flex></span></a>
        </div>
        <div *ngIf="ShowEORQuotes && !EORDisabled" >
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 1}" >
            Quotes<span flex></span>
            <span flex></span></a>
        </div>
        <div *ngIf="!EORDisabled">
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 1}" [ngClass]="{' active-side-nav': selectedService==1}">
            Assignments<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==1}"></span></a>
        </div>
        </div>

        <div class="iwg-service-name" *ngIf="!ComplianceDisabled">Compliance</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!ComplianceDisabled">
        <div *ngIf="ShowComplianceQuotes" >
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 3}" >
            Quotes<span flex></span>
            <span flex></span></a>
        </div>
        <div>
            <a  href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 3}" [ngClass]="{' active-side-nav': selectedService==3}">
            Evaluations<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==3}"></span></a>
        </div>
    </div>

    <div class="iwg-service-name" *ngIf="!AORDisabled">Agent of Record</div>
        <div class="sidenavigationInner" style="padding-bottom:0;" *ngIf="!AORDisabled">
        <div *ngIf="ShowAORQuotes" >
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/quotes']" [queryParams] = "{
                service: 2}" >
            Quotes<span flex></span>
            <span flex></span></a>
        </div>
        <div>
            <a href="javascript:void(0);" class="custom-sidemenu" layout
            [routerLink]="['/assignments']" [queryParams] = "{
                service: 2}" [ngClass]="{' active-side-nav': selectedService==2}" >
            Engagements<span [ngClass]="{'sidemenuactiveiconcolor': selectedService==2}"></span></a>
        </div>
    </div>

  
        <div class="sidenavigationInner">
            <app-buttonbar></app-buttonbar>
        </div>
</div>

    <div fxFlex="calc(100% - 240px)" fxFlex.xs="100">        
        <div *ngIf="!showFooter && this.userService.getRole() !='Worker'">
            <a mat-button href="#" *ngIf="selectedService === 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event, null, 3); $event.preventDefault();" layout="row">
                Evaluate a Contractor
                <span flex></span>
                <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
            <a mat-button href="#" *ngIf="selectedService !== 3" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="showAssignmentDialog($event); $event.preventDefault();" layout="row">
                Engage a Worker
                <span flex></span>
                <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
            <a mat-button href="#" class="mat-primary mat-raised iwg-mat-button sidenavigationassbtnembed" (click)="ShowQuoteDialog_embed($event); $event.preventDefault();" layout="row">
                Get a Quote
                <span flex></span>
                <mat-icon mat-font-set="material-icons" class="mat-iconembed">add</mat-icon>
            </a>
        </div>
        <div class="content">
            <div class="iwg-page-header-breadcrumb">
                <span *ngIf="showFooter">Services » </span><span>{{selectedServiceName}}</span> » <span class="iwg-page-header-small-title">{{assignmentLabelPlural}}</span>
            </div>
            <app-assignment-table flex="auto" [state]="state" [hideFilters]=false [service]="selectedService"></app-assignment-table>
        </div>
        <div *ngIf="showFooter" class="innerpage-footer">
            <app-iwg-footer [blurBg]="true"></app-iwg-footer>
        </div>
    </div>
</div>